export const TEST_ID = 'homePointControl';

export const PICK_BUTTON_TEST_ID = 'homePointControlPickButton';

export const COORDINATE_DECIMAL_PLACES = 5;

export const CHEVRON_CHARACTER = '›';
